<section class="flex items-center justify-between user-profile">

  <div class="flex items-center gap-3 cursor-pointer user-info" (click)="menuTrigger.openMenu()">
    <mat-icon *ngIf="!isMobile" fontSet="fa" fontIcon="fa-user"
      class="!flex items-center justify-center !text-[21px] !h-[36px] !w-[36px] text-white-600">
    </mat-icon>

    <span class="flex flex-col leading-tight user-data">
      <span *ngIf="checkIfThirdPart()" class="text-sm font-bold profile-name">{{getThirdPartLabel()}}</span>
      <span *ngIf="!isMobile" class="text-sm font-medium profile-name">{{ userName }}</span>
      <span *ngIf="!isMobile" class="text-xs text-white-500 profile-name">{{ role }}</span>
    </span>
  </div>

  <button mat-icon-button #menuTrigger="matMenuTrigger" [matMenuTriggerFor]="menu" aria-label="Profile Menu"
    class="ml-2">
    <mat-icon [ngClass]="isMobile ? '!text-[20px]' : '!text-[14px]'" fontSet="fa" [fontIcon]="iconMenuUser"
      class="!flex items-center justify-center !h-auto !w-auto"></mat-icon>
  </button>
</section>

<mat-menu #menu="matMenu" class="profile-menu">
  <div class="px-4 py-2 border-b border-white-100 profile-menu-title">
    <h4 class="m-0 text-sm font-semibold text-white-500 tracking-wider">
      {{ "manage profile" | i18n }}
    </h4>
  </div>
  <ul class="list-none p-0 m-0">
    <li *ngFor="let item of menuItems; let i = index">
      <button [myAldEvent]="item.description" myAldEventLabel="home" mat-menu-item (click)="doAction(item)"
        class="flex items-center gap-3">
        <div class="flex items-center">
          <rfc-icon class="flex" [iconInput]="setIconAttributeForRendering(item)"></rfc-icon>
          <span>{{ item.description | i18n }}</span>
        </div>
      </button>
    </li>
  </ul>
</mat-menu>